export function normalizeCheckboxes(form: HTMLFormElement) {
  for (let index = 0; index < form.elements.length; index++) {
    const element = form.elements[index]
    if (element instanceof HTMLInputElement && element.type === 'checkbox') {
      const value = element.value.toLowerCase()
      if (value === 'on' || value === '1' || value === 'yes') {
        element.value = element.checked ? 'true' : 'false'
      }
    }
  }
}

export function formDataToObject(formData: FormData) {
  const result: Record<string, unknown> = {}
  for (const [key, value] of formData) {
    setValueAtPath(result, key, value)
  }
  return result
}

export function setValueAtPathOrg<T extends Record<string, unknown> | unknown[]>(
  object: T,
  path: string,
  value: unknown
): T {
  const keys = path.replace(/\[(\d+)]/g, '.$1').split('.')
  let current: unknown = object

  const isNextKeyNumeric = (key: string) => /^\d+$/.test(key)

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const isLast = i === keys.length - 1
    const nextKey = keys[i + 1]

    if (Array.isArray(current)) {
      const index = parseInt(key, 10)

      if (current[index] == null) {
        if (isLast) {
          current[index] = value
        } else {
          current[index] = isNextKeyNumeric(nextKey) ? [] : {}
        }
      }
      current = current[index]
    } else if (current != null && typeof current === 'object') {
      const obj: Record<string, unknown> = current as Record<string, unknown>
      if (obj[key] == null) {
        if (isLast) {
          obj[key] = value
        } else {
          obj[key] = isNextKeyNumeric(nextKey) ? [] : {}
        }
      }
      current = obj[key]
    }
  }
  return object
}

export function setValueAtPath<T extends Record<string, unknown> | unknown[]>(
    object: T,
    path: string,
    value: unknown
): T {

  const keys = path.replace(/\[(.*?)\]/g, '.$1').split('.')
  let current: unknown = object

  const isNextKeyNumeric = (key: string) => /^\d+$/.test(key)

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const isLast = i === keys.length - 1
    const nextKey = keys[i + 1]

    if (Array.isArray(current)) {

      const index = parseInt(key, 10)

      if (current[index] == null) {
        current[index] = isLast
            ? value
            : (isNextKeyNumeric(nextKey) ? [] : {})
      }

      current = current[index]

    } else if (current != null && typeof current === 'object') {

      const obj = current as Record<string, unknown>

      if (obj[key] == null) {
        obj[key] = isLast
            ? value
            : (isNextKeyNumeric(nextKey) ? [] : {})
      }

      current = obj[key]
    }
  }

  return object
}
